import createRouter from './createRouter';
export { BrowserRouter, MemoryRouter, StaticRouter, Route, Redirect, Switch, Link, useLocation, useHistory, useParams, useRouteMatch, withRouter, } from 'react-router-dom';
export default createRouter;
